import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
type DismissedComponentsStore = {
  dismissedComponents: string[];
};
const initialState: DismissedComponentsStore = {
  dismissedComponents: []
};
type State = {
  data: DismissedComponentsStore;
  setDismissedComponents: (components: string[]) => void;
};
const useZustandStore = create<State>()(persist(zustandSet => ({
  data: initialState,
  setDismissedComponents: (dismissedComponents: string[]) => zustandSet(oldSession => ({
    ...oldSession,
    data: {
      dismissedComponents
    }
  }))
}), {
  version: 1,
  name: 'dismissed-components'
}));
export const useStore = (component, forceShow) => {
  const $ = _c(16);
  const {
    data,
    setDismissedComponents
  } = useZustandStore();
  let t0;
  if ($[0] !== component || $[1] !== data.dismissedComponents || $[2] !== forceShow || $[3] !== setDismissedComponents) {
    t0 = () => {
      if (forceShow) {
        setDismissedComponents(data.dismissedComponents.filter(c => c !== component));
      }
    };
    $[0] = component;
    $[1] = data.dismissedComponents;
    $[2] = forceShow;
    $[3] = setDismissedComponents;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  useEffect(t0, t1);
  let t2;
  if ($[6] !== component || $[7] !== data.dismissedComponents || $[8] !== setDismissedComponents) {
    t2 = () => setDismissedComponents([...new Set([...data.dismissedComponents, component])]);
    $[6] = component;
    $[7] = data.dismissedComponents;
    $[8] = setDismissedComponents;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const dismiss = t2;
  let t3;
  if ($[10] !== component || $[11] !== data.dismissedComponents) {
    t3 = data.dismissedComponents.includes(component);
    $[10] = component;
    $[11] = data.dismissedComponents;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const isDismissed = t3;
  let t4;
  if ($[13] !== dismiss || $[14] !== isDismissed) {
    t4 = {
      dismiss,
      isDismissed
    };
    $[13] = dismiss;
    $[14] = isDismissed;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};